import React from 'react'
import { Image } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getPageContentGallery } from '../../../../entities/PageContent'

import img1 from '../../../../shared/assets/IMG_1691.jpeg'
import img2 from '../../../../shared/assets/IMG_1704.jpeg'
import img3 from '../../../../shared/assets/IMG_1705_1.jpeg'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './GallerySection.module.scss'

const fallbackImages = [img1, img2, img3]

const GallerySection: React.FC = () => {
    const { t, i18n } = useTranslation()
    const gallerySection = useSelector(getPageContentGallery)
    const lang = i18n.language.split('-')[0]
    const isRu = lang === 'ru'

    const title = gallerySection
        ? isRu
            ? gallerySection.titleRu
            : gallerySection.titleEn
        : t('gallery.title')
    const backgroundColor = gallerySection?.backgroundColor ?? '#f4f2e8'
    const serverUrl = (process.env.REACT_APP_API_URL ?? '').replace(
        /\/api\/?$/,
        ''
    )

    const images = gallerySection?.images?.length
        ? gallerySection.images.map((image) => ({
              id: image.id,
              src: image.imageUrl.startsWith('http')
                  ? image.imageUrl
                  : `${serverUrl}${image.imageUrl}`,
              alt: image.alt ?? `${title} ${image.sortOrder + 1}`
          }))
        : fallbackImages.map((src, index) => ({
              id: String(index),
              src,
              alt: `${title} ${index + 1}`
          }))

    return (
        <PageSection
            title={title}
            variant="compact"
            style={{ backgroundColor }}
        >
            <Image.PreviewGroup>
                <ul className={cls.grid}>
                    <li className={`${cls.cell} ${cls.videoCell}`}>
                        <iframe
                            className={cls.video}
                            src="https://www.youtube.com/embed/yvt3LL3r3Ys"
                            title="YouTube Shorts"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </li>
                    {images.map((image) => (
                        <li key={image.id} className={cls.cell}>
                            <Image
                                src={image.src}
                                alt={image.alt}
                                rootClassName={cls.imageRoot}
                                className={cls.image}
                                loading="lazy"
                                preview
                            />
                        </li>
                    ))}
                </ul>
            </Image.PreviewGroup>
        </PageSection>
    )
}

export default GallerySection
